@if(showMessageError) {
  <div class="max-w-2xl mx-auto mt-10">
    <div class="bg-mustard-100 dark:bg-vivid-royal-800 border border-mustard-300 dark:border-vivid-royal-600 rounded-xl p-6 text-center">
      <i class="pi pi-exclamation-triangle text-3xl text-mustard-600 dark:text-mustard-400 mb-3 block"></i>
      <p class="text-vivid-royal-800 dark:text-dark-khaki-50">{{ msgDisabled }}</p>
    </div>
  </div>
} @else {

  @if(enProceso) {
    <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
      <app-loader [message]="'Procesando Pago'"></app-loader>
    </div>
  }

  @if(messageModal) {
    <app-alert-modal [hasButtons]="false" [isSuccess]="false" [showIcon]="true" [isHtml]="false"
      [message]="messageModal" (onCancel)="messageModal=''" (onConfirm)="messageModal=''"></app-alert-modal>
  }

  <div class="px-5 space-y-5 mt-3">
    @if(movements) {
      <div class="grid grid-cols-1 md:grid-cols-3 gap-5">

        <!-- Left: Tables -->
        <div class="md:col-span-2 space-y-5">

          @if(loading) {
            <app-loader [inline]="true" [message]="'Cargando información de pagos...'"></app-loader>
          } @else {

          <!-- Pending payments -->
          @if(searchingPending) {
            <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
              <div class="flex items-center gap-2 text-sm text-vivid-royal-400">
                <i class="pi pi-spin pi-spinner"></i> Buscando pagos pendientes...
              </div>
            </div>
          } @else if(pendingPayments.length > 0) {
            <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-3">
              <div class="flex items-center gap-2">
                <i class="pi pi-exclamation-circle text-mustard-600"></i>
                <h2 class="text-sm font-semibold text-mustard-700 dark:text-mustard-400">Pagos realizados sin aplicar</h2>
              </div>
              <p class="text-xs text-vivid-royal-400">
                Si realizó un pago y no se ve aplicado, confirme la referencia y presione "Finalizar pago"
              </p>
              <app-custom-table [rowsByPage]="50" [headers]="headersPayment" [elements]="pendingPayments"
                [actions]="actionsPending" [hasButton]="true" [hasFilter]="false"></app-custom-table>
            </div>
          }

          <!-- Payments / Invoices -->
          <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-3">
            @if(data.PurchaseType !== 'Credit') {
              <h2 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Últimos pagos</h2>
              <app-custom-table [rowsByPage]="50" [headers]="headers" [elements]="movements"
                [hasButton]="false" [hasFilter]="true"></app-custom-table>
            } @else {
              <h2 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">Facturas Pendientes</h2>
              <app-custom-table-icon [headers]="headersCredit" [elements]="invoices" [hasButton]="false"
                [hasFilter]="false" [iconName]="'Square'" [iconNameSelect]="'SquareCheckBig'"
                [emptyTableMessage]="'No hay facturas pendientes'" [iconColumn]="'id'"
                (dataSelect)="calculatePayment($event)"></app-custom-table-icon>
            }
          </div>
          }
        </div>

        <!-- Right: Payment card -->
        <div>
          <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-4 sticky top-24">
            <h2 class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">
              {{ data.PurchaseType === 'Credit' ? 'Pagar facturas' : 'Agregar saldo' }}
            </h2>

            <div>
              <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Total a pagar</label>
              <div class="relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 text-vivid-royal-400 text-sm">$</span>
                <input pInputText type="text" [disabled]="data.PurchaseType === 'Credit'" mask="separator.2"
                  [allowNegativeNumbers]="false" [(ngModel)]="amount" placeholder="0.00"
                  class="w-full pl-8 text-right text-lg" />
              </div>
            </div>

            <!-- Future: card form will go here -->
            <div class="border-t border-dark-khaki-200 dark:border-vivid-royal-700 pt-4">
              <p class="text-xs text-vivid-royal-400 mb-3">
                <i class="pi pi-lock mr-1"></i> Serás redirigido a la plataforma de pagos segura
              </p>
              @if((data.PurchaseType === 'Credit' && amount) || data.PurchaseType !== 'Credit') {
                <button pButton [label]="enProceso ? 'Procesando...' : 'Realizar pago'" icon="pi pi-credit-card"
                  class="p-button-sm w-full" [disabled]="enProceso || !amount" (click)="doPayment()"></button>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Hidden payment form -->
      <form name="Form" id="Form" [action]="mpUrl" method="post" target="_top" #paymentForm class="hidden">
        <input type="hidden" name="t_servicio" value="231">
        <input type="hidden" name="url_response" [value]="urlWebhook">
        <input type="hidden" name="param_c_b_1" value="10703">
        <input type="hidden" name="param_c_b_2" value="0">
        <input type="hidden" name="param_c_b_4" value="1">
        <input type="hidden" name="param_c_b_5" value="1">
        <input type="hidden" name="param_c_b_6" value="1">
        <input type="hidden" name="param_c_b_7" value="0">
        <input type="hidden" name="param_c_b_18" value="1110">
        <input type="hidden" name="mp_autosubmit_time" value="6000">
      </form>
    }
  </div>
}
